__turbopack_context__.v({
  "container": "kxdwdq_container",
  "innerContainer": "kxdwdq_innerContainer",
  "notResultStyles": "kxdwdq_notResultStyles",
  "thumbNailContainer": "kxdwdq_thumbNailContainer",
});
